export const formActions = {
	cancel: "Fechar",
	create: "Concluir cadastro",
	save: "Salvar alterações",
	validationError: {
		title: "Erro de validação do formulário",
		description: "Por favor corrija {{count}} erro(s) nas seguintes abas: {{tabs}}",
	},
};
